import React from 'react';
import { SERVER_ERROR } from '../../constants/messages';
import Api from '../../api/api';
import AppAuthStore from '../../stores/login-store';
import UpgradeButton from '../../components/upgrade/upgrade-button';
import DowngradeButton from '../../components/upgrade/downgrade-button';
import AuthMixin from '../../mixins/authenticationMixin';

import AppSettingsNotice from '../../components/notices/notice';

import UserDetailsModern from './user-details-modern';
import './user-details.scss';
import '../../../css/design-system.scss';

class UserDetails extends React.Component {
  constructor() {
    super();
    this.nameRef = React.createRef();
    this.emailRef = React.createRef();
    this.receiveMessagesRef = React.createRef();
    this.currentPasswordRef = React.createRef();
    this.state = {
      emailChanged: false,
      success: false,
      fail: false,
      empty_fields: false,
      loading: false,
      ...AppAuthStore.getSessionUserData()
    };
    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    AppAuthStore.addChangeListener(this._onChange);
  }

  componentWillUnmount() {
    AppAuthStore.removeChangeListener(this._onChange);
  }

  _onChange(data) {
    // a background refresh of the saved user, not the result of saving this form: update the
    // plan details, but leave what's being edited alone
    if (data && data.refreshed) {
      const { account_type, free_trial_expired, free_trial_expires_at } = AppAuthStore.getSessionUserData();
      return this.setState({ account_type, free_trial_expired, free_trial_expires_at });
    }

    if (data && data.success) {
      this.setState({
        success: !!data.success,
        fail: data.success? false : true,
        empty_fields: false,
        emailChanged: false,
        loading: false
      });
    } else {
      this.setState({
        fail: true,
        loading: false
      });
    }

  }

  renderNotice() {
    if (this.state.fail && this.state.empty_fields) {
      return <AppSettingsNotice type="error">Please complete all fields to continue.</AppSettingsNotice>;
    }
    if (this.state.success) {
      return <AppSettingsNotice type="success">Your profile has been updated.</AppSettingsNotice>;
    }
    return <AppSettingsNotice type="error">{SERVER_ERROR}</AppSettingsNotice>;
  }

  validateData(data) {
    if (Api.hasEmptyFields(data)) {
      return {error: true}
    }
    return {error: false}
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ loading: true })

    const nameInput = this.nameRef.current || this.refs.name;
    const emailInput = this.emailRef.current || this.refs.email;
    const receiveMessagesInput = this.receiveMessagesRef.current || this.refs.receive_messages;

    if (!nameInput || !emailInput) return;

    const data = {
      name: nameInput.value,
      email: emailInput.value,
      receive_messages: receiveMessagesInput.checked ? 1 : 0
    };

    if (this.state.emailChanged) {
      const currentPasswordInput = this.currentPasswordRef.current;
      data.current_password = currentPasswordInput ? currentPasswordInput.value : '';
    }

    if (this.validateData(data).error) {
      return this.setState({
        fail: true,
        empty_fields: true,
        loading: false
      });
    }

    AppAuthStore.updateUser(this.props.userApiRequest, data);
  }

  upgradable() {
    const {
      account_type
    } = AppAuthStore.getSessionUserData();

    if ( account_type === "Starter" ) {
      return <UpgradeButton {...this.props} />
    } else {
      return <DowngradeButton {...this.props} />
    }
  }

  render() {
     const {
      account_type,
      created_at,
      name,
      email,
      receive_messages,
      free_trial_expired,
      free_trial_expires_at
    } = this.state;

    let success = (this.state.success || this.state.fail)? this.renderNotice() : null;

    return (
        <UserDetailsModern
            {...this.props}
            {...this.state}
            name={name}
            email={email}
            receive_messages={receive_messages}
            account_type={account_type}
            created_at={created_at}
            free_trial_expired={free_trial_expired}
            free_trial_expires_at={free_trial_expires_at}
            loading={this.state.loading}
            
            nameRef={this.nameRef}
            emailRef={this.emailRef}
            receiveMessagesRef={this.receiveMessagesRef}
            currentPasswordRef={this.currentPasswordRef}
            handleEmailChange={(e) => this.setState({ emailChanged: e.target.value !== AppAuthStore.getSessionUserData().email })}
            
            successNotice={success}
            handleSubmit={this.handleSubmit.bind(this)}
            upgradable={this.upgradable()}
            handleMessageChange={() => this.setState({receive_messages: !this.state.receive_messages})}
        />
    );
  }
}

export default AuthMixin(UserDetails);
